import {
    RaikoGridOneColumn, RaikoGridThreeColumn, RaikoPagination,
    RaikoTableTitleContainer, showServerErrorMessage,RaikoCardInfoTypeOne,RaikoCardInfoTypeOneItemGenerator
} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";
import {ResidenceService} from "../../../service/residence/ResidenceService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {createResidenceTableRow} from "../../residences/ResidenceHelper";
import {css} from "@emotion/css";

export default function SelectResidenceFromList({selectResidence}) {

    let page = 0
    const size = 12

    const service = new ResidenceService()

    const loading = new LoadingHelper(useLoadingDispatcher())

    const [numberOfItems, setNumberOfItems] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [residenceListData, setResidenceListData] = useState([]);



    useEffect(() => {
        getDataFromServer();

    }, []);


    function getDataFromServer() {
        loading.show()
        service.getResidenceList(page, size)
            .then(response => {

                setPageCount(response.totalPage)
                setNumberOfItems(response.numberOfItems)
                setResidenceListData([])

                response.data.map((item, index) => {
                    setResidenceListData(prevState => [
                        ...prevState,
                        createResidenceTableRow(
                            (page * size) + index + 1,
                            item.id,
                            item.metaData ? item.metaData.title : "-",
                            item.metaData && item.metaData.address ? item.metaData.address.slice(0, 20) + " ..." : "-",
                            item.menCapacity,
                            item.womenCapacity,
                            item.createdAt,
                            item.createdBy
                        )
                    ])
                })

                loading.hide()
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handlePagination(newPage) {
        page = newPage
        getDataFromServer()
        window.scrollTo({ top: 0, behavior: "smooth" });
    }

    function handleSelectItem(rowId) {
        if (selectResidence) {
            for (let i = 0; i < residenceListData.length; i++) {
                if (residenceListData[i].id === rowId) {
                    selectResidence(residenceListData[i]);
                    break;
                }
            }
        }
    }

    return (
        <>
            <RaikoGridOneColumn className={css`width: 100%`}>
                <RaikoTableTitleContainer
                    title={"اقامتگاه ها"}
                    amount={numberOfItems}
                    subTitle={"اقامتگاه مورد نظر را انتخاب نمایید"}
                />
                {/*<RaikoCustomTable*/}
                {/*    isLoading={false}*/}
                {/*    data={residenceListData}*/}
                {/*    header={residenceTableHeader}*/}
                {/*    handlePaginationChange={handlePagination}*/}
                {/*    pageCount={pageCount}*/}
                {/*    rowClicked={handleSelectItem}*/}
                {/*/>*/}
                <RaikoGridThreeColumn>
                    {residenceListData.map((item, index) => {
                        return <RaikoCardInfoTypeOne
                            key={index}
                            title={item.title}
                            iconClass={"ic_residence"}
                            items={[
                                RaikoCardInfoTypeOneItemGenerator("تعداد آقا", item.menCapacity),
                                RaikoCardInfoTypeOneItemGenerator("تعداد خانم", item.womenCapacity),
                                RaikoCardInfoTypeOneItemGenerator("آدرس", item.address),
                                // RaikoCardInfoTypeOneItemGenerator("تاریخ ساخت", item.createdAt),
                                // RaikoCardInfoTypeOneItemGenerator("سازنده", item.createdBy),
                            ]}
                            onClick={_ => {
                                handleSelectItem(item.id)
                            }}

                        />
                    })}
                </RaikoGridThreeColumn>
                <RaikoPagination pageCount={pageCount} handlePaginationChange={handlePagination}/>


            </RaikoGridOneColumn>
        </>
    )
}